import { PureComponent } from 'react'

interface BarChartSVGProps {
    size?: number
}

class BarChartSVG extends PureComponent<BarChartSVGProps> {
    render() {
        const { size } = this.props
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid" style={{ fontSize: `${size}rem` }} aria-hidden="true">
                <rect x="26" y="8" width="6" height="32" rx="2" fill="#A3A3A3" />
                <rect opacity="0.3" x="16" y="18" width="6" height="22" rx="2" fill="#A3A3A3" />
            </svg>
        )
    }
}

export default BarChartSVG
